
import { computed, defineComponent, PropType } from 'vue';
import { AllCourses } from '../../types';
import { SelectedCourseInfo } from './types';
import LessonList from './components/LessonList.vue';

export default defineComponent({
  components: {
    LessonList,
  },
  props: {
    selectedCoursesIds: { type: Set as PropType<Set<number>>, required: true },
    selectedCoursesIdsFromDatabase: { type: Set as PropType<Set<number>>, required: true },
    courses: { type: Object as PropType<AllCourses>, required: true },
  },
  emits: ['conflict-resolved'],
  setup(props, ctx) {
    return {
      /** （展示用）仅存在于本地的课程列表 */
      selectedCoursesOnlyInLocal: computed<SelectedCourseInfo[]>(() =>
        [...props.selectedCoursesIds]
          .filter((x) => !props.selectedCoursesIdsFromDatabase.has(x))
          .map((courseId) => ({
            codeId: props.courses[courseId].code_id,
            name: props.courses[courseId].name,
          }))),
      /** （展示用）仅存在于服务端的课程列表 */
      selectedCoursesOnlyInDataBase: computed<SelectedCourseInfo[]>(() =>
        [...props.selectedCoursesIdsFromDatabase]
          .filter((x) => !props.selectedCoursesIds.has(x))
          .map((courseId) => ({
            codeId: props.courses[courseId].code_id,
            name: props.courses[courseId].name,
          }))),

      /** 解决冲突回调 */
      handleChoosen(choice: 'both' | 'local' | 'cloud') {
        if (choice === 'both') {
          const combinedSelectedCoursesIds = new Set([
            ...props.selectedCoursesIds,
            ...props.selectedCoursesIdsFromDatabase,
          ]);
          ctx.emit('conflict-resolved', combinedSelectedCoursesIds, true, true);
        } else if (choice === 'local') {
          ctx.emit('conflict-resolved', props.selectedCoursesIds, false, true);
        } else if (choice === 'cloud') {
          ctx.emit('conflict-resolved', props.selectedCoursesIdsFromDatabase, true, false);
        }
      },
    };
  },
});
